var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBranding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.57886 6.68182V16.5H10.0602V12.7846H12.0737C12.1058 12.7846 12.1376 12.7844 12.1691 12.784L14.1639 16.5H15.8514L13.6784 12.532C13.7791 12.4942 13.8754 12.4522 13.9674 12.4059C14.4723 12.1534 14.8495 11.8002 15.0987 11.3464C15.3512 10.8894 15.4775 10.3604 15.4775 9.75959C15.4775 9.15554 15.3528 8.6234 15.1035 8.16317C14.8542 7.69975 14.4771 7.337 13.9721 7.07493C13.4704 6.81285 12.8392 6.68182 12.0785 6.68182H8.57886ZM10.0602 11.5094H11.9395C12.4189 11.5094 12.8088 11.4407 13.1092 11.3033C13.4128 11.1658 13.635 10.9661 13.7756 10.704C13.9162 10.4419 13.9865 10.1271 13.9865 9.75959C13.9865 9.38885 13.9146 9.06765 13.7708 8.79599C13.6302 8.52432 13.408 8.31658 13.1044 8.17276C12.804 8.02574 12.4093 7.95224 11.9203 7.95224H10.0602V11.5094Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBranding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/branding.2cb7592069fca24f13d8c394643de9d6.svg";